export default __webpack_public_path__ + "static/blob10-ff99267cd581d3be5fd27f7eaa8504f1.svg";